import React, {createContext, useContext, useState} from 'react';
import Alert from '@parkagent/ui/dist/components/Alert';

const Context = createContext({
    alerts: [],
})

export function useAlert() {
    return useContext(Context);
}

export function AlertContext(props) {

    const [alertData, setAlertData] = useState()

    function setAlert(type, text) {

        if (type && text) {
            return setAlertData({
                type,
                text,
                visible: true,
                setVisible: (e) => setAlertData(e)
            });
        }
    }

    return (
        <Context.Provider
            value={{
                setAlert
            }}
        >

            {props.children}

            {alertData?.visible &&
                <Alert {...alertData} />
            }

        </Context.Provider>
    )
}